import { __decorate, __metadata } from "tslib";
import { IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsNumber, IsString } from 'class-validator';
import { WebStoreExposeGroup } from '../interface';
export class PatchWebStoreThemePromotionsBarDto {
    constructor() {
        this.color = 'var(--notification-color)';
        this.background = 'var(--notification-bg)';
        this.fontSize = '14px';
        this.textTransform = 'none';
        this.weight = 400;
    }
}
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreThemePromotionsBarDto.prototype, "color", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreThemePromotionsBarDto.prototype, "background", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreThemePromotionsBarDto.prototype, "fontSize", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    LengthWithLVS(1, 50, { always: true }),
    __metadata("design:type", String)
], PatchWebStoreThemePromotionsBarDto.prototype, "textTransform", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], PatchWebStoreThemePromotionsBarDto.prototype, "weight", void 0);
//# sourceMappingURL=PatchWebStoreThemePromotionsBarDto.js.map